<!-- title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div
      class="tw-mt-[10px] tw-rounded-[10px] tw-items-center bg-light rounded tw-p-5 tw-mb-5"
    >
      <span>{{ "messages.searchAggregator" | translate }}</span>
    </div>

    <div class="row">
      <div class="tw-w-full">
        <div class="tw-flex-center tw-flex-col">
          <!-- mobile -->
          <form-field
            [(value)]="mobile"
            (input)="aggregator = null"
            class="tw-w-full"
            [control]="form?.get('mobile')"
            [isMobileField]="true"
            label="common.mobile"
            type="tel"
            [maxLength]="12"
          >
          </form-field>
        </div>
        <div
          *ngIf="aggregator != null"
          [class]="
            aggregator == SmsAggregator.MCI
              ? 'bg-light-sky text-sky'
              : aggregator == SmsAggregator.Irancell
              ? 'bg-light-warning text-warning'
              : aggregator == SmsAggregator.Rightel
              ? 'bg-light-purple text-purple'
              : aggregator == SmsAggregator.Other
              ? 'bg-light-brown text-brown'
              : 'bg-light-slate text-slate'
          "
          class="tw-mt-[10px] fw-bold tw-rounded-[10px] tw-flex tw-items-center rounded p-5"
        >
          <img
            [src]="getSmsAggregatorImg(aggregator)"
            [width]="getSmsAggregatorImgWidth(aggregator)"
            class="tw-ml-[10px] ltr:tw-mr-[10px]"
          />
          <span copyToClipboard>{{
            aggregator | enumToText : SmsAggregatorsEnumValues
          }}</span>
        </div>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [customTitle]="'common.search'"
      [btnType]="'submit'"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
